module.exports = __webpack_public_path__ + "static/img/images_AS02.b5201e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/images_AS02.jpg
// module id = F4GI
// module chunks = 0